import React from 'react'
import PropTypes from 'prop-types'
import { find, map, size } from 'lodash'
import { StickyContainer, Sticky } from 'react-sticky'

import Peers from '../Peers/Peers'

import {
  PlaceBuilding,
  PlaceAddress,
  PlaceHours,
  LocationLi,
  LocationUl,
  Top,
  ProgramHeader,
} from './styles.css'

function LocationItem({ location, students, isShowThree, isShowTwo, program }) {
  if (!location) return <p>No location.</p>
  const { name, galleryHours, building, streetAddress, zip } = location
  return (
    <LocationLi>
      <StickyContainer>
        <Sticky>
          {({ style }) => (
            <div style={style}>
              <Top>{name}</Top>
            </div>
          )}
        </Sticky>
        <section>
          <PlaceBuilding>{building}</PlaceBuilding>
          <PlaceAddress>
            {streetAddress} {zip}
          </PlaceAddress>
          {galleryHours && (
            <PlaceHours className="openHours">
              Open Hours:
              <br /> {galleryHours}
            </PlaceHours>
          )}
          {isShowTwo && program && (
            <ProgramHeader>{program[Object.keys(program)[0]].name}</ProgramHeader>
          )}
          {size(students) > 0 && (
            <div>
              <Peers students={students} />
            </div>
          )}
        </section>
      </StickyContainer>
    </LocationLi>
  )
}
LocationItem.propTypes = {
  location: PropTypes.shape({
    name: PropTypes.string,
    galleryHours: PropTypes.string,
  }),
  students: PropTypes.objectOf(PropTypes.object),
  isShowThree: PropTypes.bool,
  isShowTwo: PropTypes.bool,
  program: PropTypes.objectOf(PropTypes.object),
}
LocationItem.defaultProps = {
  location: null,
  students: null,
  isShowThree: false,
  isShowTwo: false,
  program: null,
}

function LocationList({ show, isShowThree, isShowTwo, program }) {
  return (
    <div>
      <LocationUl>
        {map(show, item => (
          <LocationItem
            key={item.id}
            location={find(item.location)}
            students={item.student}
            isShowThree={isShowThree}
            isShowTwo={isShowTwo}
            program={item.program}
          />
        ))}
      </LocationUl>
    </div>
  )
}
LocationList.propTypes = {
  reception: PropTypes.string,
  show: PropTypes.objectOf(PropTypes.object),
  isShowTwo: PropTypes.bool,
  isShowThree: PropTypes.bool,
  program: PropTypes.objectOf(PropTypes.object),
}
LocationList.defaultProps = {
  reception: null,
  show: null,
  isShowTwo: false,
  isShowThree: false,
  program: null,
}
export default LocationList
